import { shallowRef } from 'vue';
import { apiRequest } from '@/api/http';

// How many registrations are waiting for verification, shared by the
// sidebar's Accounts pill and the Accounts page's "For verification" tab so
// verifying someone updates both. The server already limits the list to the
// admin's level, so a JHS Admin only counts JHS registrations.
const PENDING_URL = '/user-details/getAllUsersToVerify';
const count = shallowRef(0);

async function refresh() {
  try {
    const rows = await apiRequest('get', PENDING_URL);
    count.value = Array.isArray(rows) ? rows.length : 0;
  } catch {
    // Only a hint: keep the last count rather than show an error.
  }
}

function set(n) {
  count.value = n;
}

export function usePendingAccounts() {
  return { count, refresh, set, PENDING_URL };
}
